export default __webpack_public_path__ + "static/media/footer-bg.423f0102.png";